import React from 'react';
import Flex from '../data/Flex';
import Size from '../data/Size';
import UIFlex, { copyFlex, IUIFlexProps } from './UIFlex';
import UIIcon from './UIIcon';
import './UIInput.scss';

export interface IUIInputProps extends IUIFlexProps{
    name:string;
    className?:string;
    label?:string | JSX.Element;
    labelExtra?:JSX.Element;
    type?:string;
    tabIndex?:number;
    value?:string | number | boolean;
    valueExtra?:JSX.Element;
    isRequired?:boolean;
    maxLength?:number;
    placeholder?:string;
    options?:{label:string, value:string}[];
    size?:string;
    fontSize?:string;
    iconSize?:string;
    style?:string;
    disabled?:boolean;
    autoComplete?:string;
    onChange?:($value:string | number | boolean, $name:string)=>void;
    onBlur?:($value:string, $name:string)=>void;
}

export interface IUIInputState {
    focused:boolean;
}

export default class UIInput extends React.PureComponent<IUIInputProps, IUIInputState> {

    inputElement:React.RefObject<HTMLInputElement> = React.createRef();

    /**
     * Default TEXT
     */
    static TYPE_TEXT:string = "text";
    static TYPE_PASSWORD:string = "password";
    static TYPE_TEXTAREA:string = "textarea";
    static TYPE_SELECT:string = "select";
    static TYPE_CHECKBOX:string = "checkbox";

    static STYLE_NORMAL:string = "styleNormal";
    static STYLE_LABEL_AS_PLACEHOLDER:string = "styleLableAsPlaceholder";


    constructor(props: IUIInputProps) {
        super(props);

        this.state = {
            focused:false
        }
    }

    _change=($value:string | number | boolean)=>{
        if(this.props.onChange && this.props.name){
            this.props.onChange($value,this.props.name);
        }
    }

    _blur=($value:string)=>{
        if(this.props.onBlur && this.props.name){
            this.props.onBlur($value,this.props.name);
        }
    }

    _onInput=($event:React.ChangeEvent<HTMLInputElement>)=>{
        this._change($event.target.value);
    }
    _onCheckbox=($event:React.ChangeEvent<HTMLInputElement>)=>{
        this._change(!this.props.value);
    }

    _onTextArea=($event:React.ChangeEvent<HTMLTextAreaElement>)=>{
        this._change($event.target.value);
        
    }
    _onSelect=($event:React.ChangeEvent<HTMLSelectElement>)=>{
        this._change($event.target.value);
    }
    _onFocus=($event:React.FocusEvent)=>{
        this.setState({focused:true});
    }
    _onBlur=($event:React.ChangeEvent<HTMLTextAreaElement>)=>{
        this._blur($event.target.value);
        this.setState({focused:false});
    }




    render() {

        let cn:string = "input";
        let cnElement:string = "inputElement";
        let cnLabel:string = "inputLabel";
        let cnCheckIcon:string = "checkIcon"

        if(this.props.className) cn+=" "+this.props.className;
        if(this.props.isRequired) cn+=" isRequired";

        let style = UIInput.STYLE_NORMAL;
        if(this.props.style) style = this.props.style;
        cn+=" "+style;

        if(this.state.focused){
            cn+=" focused";
        }

        if(this.props.value){
            cn+=" hasValue";
        }

        if(this.props.disabled){
            cn+=" disabled";
        }

        if(this.props.autoComplete){
            cn+=" new-password";
        }

        cnCheckIcon = Size.addFontSize(cnCheckIcon,this.props.iconSize,Size.s26);


        cn = Size.addFontSize(cn,this.props.fontSize);
        cnElement = Size.addSize(cnElement,this.props.size);


        let type:string = this.props.type || "text";

        let autoComplete:string = this.props.autoComplete || "";

        let jsxInputElement:JSX.Element = <></>;

        let sharedProps:any = {};
        sharedProps.className = cnElement;
        sharedProps.name = this.props.name;
        sharedProps.id = "input_"+this.props.name;
        sharedProps.ref = this.inputElement;
        sharedProps.onBlur = this._onBlur;
        sharedProps.onFocus = this._onFocus;
        sharedProps.disabled = this.props.disabled;

        let jsxExtra:JSX.Element = <></>;

        if(this.props.maxLength){
            sharedProps.maxLength = this.props.maxLength;
        }

        switch(type){
            case UIInput.TYPE_TEXTAREA:
                jsxInputElement = (
                    <textarea placeholder={this.props.placeholder} tabIndex={this.props.tabIndex} {...sharedProps} value={this.props.value} onChange={this._onTextArea}
                    onBlur={this._onBlur}/>
                );
            break;
            case UIInput.TYPE_SELECT:


                jsxInputElement = (
                    <select tabIndex={this.props.tabIndex} {...sharedProps} value={this.props.value} onChange={this._onSelect} >
                        {this.props.options && this.props.options.map(($option, $optionIndex)=>{
                            return (
                                <option key={this.props.name+"option"+$optionIndex+$option.value} label={$option.label} value={$option.value}/>
                            );
                        })}
                    </select>
                );
                jsxExtra = (
                    <UIIcon className='selectIcon' icon={UIIcon.CHEVRON_DOWN}/>
                );
            break;
            case UIInput.TYPE_CHECKBOX:
                    cn+=" inputCheckbox";
                    if(this.props.value){
                        cn+=" checked";
                    }
                    jsxInputElement = (
                        <>
                            <input tabIndex={this.props.tabIndex} {...sharedProps} type={type} checked={this.props.value} onChange={this._onCheckbox}/>
                            <UIIcon className={cnCheckIcon} icon={UIIcon.CHECK}/>
                        </>
                    );
            break;
            case UIInput.TYPE_PASSWORD:
            default: //"text"
                jsxInputElement = (
                    <input  placeholder={this.props.placeholder} autoComplete={autoComplete} tabIndex={this.props.tabIndex} onChange={this._onInput} type={type}  value={this.props.value} {...sharedProps} />                    
                );
            break;
        }

        return (
            <UIFlex 
                className={cn} 
                flex={copyFlex({inline:true, direction:Flex.COLUMN},this.props.flex)}
            >
                {this.props.label && (
                    <label className={cnLabel} htmlFor={"input_"+this.props.name}>
                        {this.props.label}
                        {this.props.isRequired && (
                            <span className="required">*</span>
                        )}
                        {this.props.labelExtra}
                    </label>
                )}
                <div className="elementWrapper">
                    {jsxInputElement}
                    {jsxExtra}
                    {this.props.valueExtra}
                </div>
                {this.props.children}
            </UIFlex>
        );
    }
}
